import Nav from "./../Page/Share/Nav/Nav";
const Post19 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Ecommerce Website UI Design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/XLTkcyR/1.png" alt="" />
          <img src="https://i.ibb.co/jb1dVrg/2.png" alt="" />
          <img src="https://i.ibb.co/fFFqhsv/3.png" alt="" />
          <img src="https://i.ibb.co/jy68RQZ/4.png" alt="" />
          <img src="https://i.ibb.co/6BL88Q2/5.png" alt="" />
          <img src="https://i.ibb.co/FKGVwSY/6.png" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post19;
